import ProgressBarV2 from "./progress-bar-v2"

export default ProgressBarV2
